"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _dateHelpers = require("../../utils/date-helpers");
var _AirDateFormatter = _interopRequireDefault(require("../utils/AirDateFormatter"));
var _ImageCard = _interopRequireDefault(require("../block/ImageCard"));
var _Concat = _interopRequireDefault(require("../utils/Concat"));
var _StringList = _interopRequireDefault(require("../utils/StringList"));
var _UpcomingListModule = _interopRequireDefault(require("./../../scss/lists/UpcomingList.module.scss"));
require("./../../scss/lists/UpcomingList.scss");
function UpcomingList(_ref) {
  let {
    list,
    handleClicks = () => true
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: _UpcomingListModule.default['upcoming-list']
  }, list.length > 0 && list.map(item => {
    var _item$title, _item$title2;
    const runTimeStr = (0, _helpers.getMinutesFromStr)(item.title.element_length);
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _helpers.classes)([_UpcomingListModule.default['upcoming-list__item'], 'upcoming-list__item']),
      key: "upcoming-list-".concat(item.id)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _helpers.classes)([_UpcomingListModule.default['upcoming-list__airdate'], 'upcoming-list__airdate'])
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _helpers.classes)([_UpcomingListModule.default['upcoming-list__airdate-bg'], 'upcoming-list__airdate-bg'])
    }, (0, _dateHelpers.determineIfShowIsOnNow)(item.airdate, item.title.element_length) && /*#__PURE__*/_react.default.createElement("div", {
      className: "upcoming-list__on-now"
    }, "On Now"), /*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
      airdateStr: item.airdate,
      separatorType: "line-break"
    }))), /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
      id: item.id,
      image: {
        url: item.title.image.url,
        altText: "",
        aspectRatio: 330 / 185
      },
      title: "",
      content: /*#__PURE__*/_react.default.createElement(_Concat.default, {
        list: ["<div>EP ".concat(item.title.episode_number, ": ").concat(item.title.name, "</div><div>").concat(item.title.synopsis, "</div>"), /*#__PURE__*/_react.default.createElement(_StringList.default, {
          list: (_item$title = item.title) !== null && _item$title !== void 0 && (_item$title = _item$title.video) !== null && _item$title !== void 0 && _item$title.brightcove_id ? [runTimeStr, item.title.rating, '&nbsp;'] : [runTimeStr, item.title.rating],
          separatorType: "pipe"
        })]
      }),
      cta: (_item$title2 = item.title) !== null && _item$title2 !== void 0 && (_item$title2 = _item$title2.video) !== null && _item$title2 !== void 0 && _item$title2.brightcove_id ? {
        label: "Watch Episode",
        type: 'play-video',
        href: '',
        relatedResourceId: item.title.video.brightcove_id,
        position: 'inline'
      } : {},
      clampContentLines: false,
      displayInline: true,
      handleClicks: handleClicks
    }));
  }));
}
var _default = exports.default = UpcomingList;